import script from "./AuthPromptModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AuthPromptModal.vue?vue&type=script&setup=true&lang=js"

import "./AuthPromptModal.vue?vue&type=style&index=0&id=35b7c32a&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b7c32a"]])

export default __exports__